/* eslint-disable no-useless-escape */

export const passwordRegex = '^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$';
export const einRegex = /^[0-9]{2}-[0-9]{7}$/;
export const emailRegex = /^[a-zA-Z]([a-zA-Z0-9]+|[._+-](?![._+-]))*[a-zA-Z0-9]@[a-zA-Z0-9]+(\.[a-zA-Z]{2,})+$/;
export const zipcodeRegex = /^[0-9]{5}(?:-[0-9]{4})?$/;
export const phoneRegex = /^(?:\+1\s?)?(?:\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/;
export const naicsCodeRegex = /^[0-9]{2}-[0-9]{2}$|^[0-9]{2,6}$/;
export const regulatoryIdRegex = /^\d{4}-[\da-zA-Z]{4}$/;
